export const FETCH_BUNDLES_REQUEST = "FETCH_BUNDLES_REQUEST";
export const FETCH_BUNDLES_SUCCESS = "FETCH_BUNDLES_SUCCESS";
export const FETCH_BUNDLES_FAILURE = "FETCH_BUNDLES_FAILURE";
export const SET_BUNDLES_CRYPTO = "SET_BUNDLES_CRYPTO";
